import { buildTimeDuration } from './buildTimeDuration';
import { padTimeInteger } from './padTimeInteger';

/**
 * A string representation of a duration for a media. Assumes most medias
 * are under an hour so only shows hours if media is over hour.
 *
 * @param {number} numberOfMilliseconds - number of milliseconds
 * @returns {string} - a string representation for duration
 */
export const mediaDurationString = (numberOfMilliseconds: number): string => {
  const { hours, minutes, seconds } = buildTimeDuration(numberOfMilliseconds);

  if (hours < 1) {
    return `${minutes}:${padTimeInteger(seconds)}`;
  }

  return `${hours}:${padTimeInteger(minutes)}:${padTimeInteger(seconds)}`;
};
